const STORAGE_KEY = 'commonRecruitmentProfile';

/**
 * 共通採用プロフィールをlocalStorageに保存する。
 * 空でないフィールドのみ保存（既存値を上書きしない）。
 */
export function saveCommonFields({ position, salary, location }) {
  try {
    const existing = loadCommonFields();
    const updated = { ...existing };
    if (position) updated.position = position;
    if (salary) updated.salary = salary;
    if (location) updated.location = location;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  } catch (e) {
    // localStorage unavailable — silently ignore
  }
}

/**
 * localStorageから共通採用プロフィールを読み込む。
 */
export function loadCommonFields() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    return JSON.parse(raw);
  } catch (e) {
    return {};
  }
}
